// extracted by mini-css-extract-plugin
module.exports = {"root--elevated":"Card-module__root--elevated___sQ3XH"};